import React from "react";
import { Mic, Cookie } from "lucide-react";

// Playful Q&A with recognisable reporter identities. Answers are the owner's own words (edited for clarity/humour with permission).
export default function InterviewQA({ interview, pupName, testid = "rc-interview" }) {
  if (!interview?.length) return null;
  return (
    <section className="bg-white rounded-3xl soft-shadow p-5 sm:p-7" data-testid={testid}>
      <p className="text-[11px] font-bold uppercase tracking-wider text-[#19324A]/55">Exclusive interview</p>
      <h2 className="font-display font-extrabold text-2xl sm:text-3xl text-[#19324A] mt-1">🎤 Chewie &amp; Solo Get the Scoop!</h2>
      <div className="mt-3 grid sm:grid-cols-2 gap-2 text-xs">
        <p className="rounded-2xl bg-[#FFD93D]/30 px-3 py-2 text-[#19324A]"><Mic className="inline w-3.5 h-3.5 mr-1" /><strong>Chewie</strong> — Senior Pawparazzi Correspondent. The professional questions.</p>
        <p className="rounded-2xl bg-[#A78BFA]/25 px-3 py-2 text-[#19324A]"><Cookie className="inline w-3.5 h-3.5 mr-1" /><strong>Solo</strong> — Chief Biscuit Investigator. Biscuit supplies and other extremely important matters.</p>
      </div>
      <ol className="mt-5 space-y-4">
        {interview.map((qa) => {
          const solo = qa.reporter.name === "Solo";
          return (
            <li key={qa.id} className="grid grid-cols-[44px_1fr] gap-3" data-testid={`${testid}-${qa.id}`}>
              <span className={`w-11 h-11 rounded-full inline-flex items-center justify-center font-display font-extrabold text-sm ${solo ? "bg-[#A78BFA] text-white" : "bg-[#FFD93D] text-[#19324A]"}`} aria-hidden="true">{solo ? "S" : "C"}</span>
              <div>
                <p className="text-sm font-bold text-[#19324A]"><span className="text-[#19324A]/55">{qa.reporter.name}{qa.bonus ? " (bonus question)" : ""}:</span> {qa.q}</p>
                <p className="mt-1.5 rounded-2xl bg-[#FFF9EE] px-4 py-3 text-[#19324A] text-sm leading-relaxed"><span className="font-bold text-[#FF6B9D]">{pupName}:</span> {qa.a}</p>
              </div>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
